import layout from './modules/layout';
import ajax_pagination from './modules/ajax_pagination';
import main_menu from './modules/main_menu';
import forms from './modules/forms';
import case_studies from './modules/case_studies';
import techologies from './modules/techologies';
import reviews from './modules/reviews';
import map from './modules/map';
import google_map_dark_styles from './modules/google-map-dark-styles';
import media_carousel from './modules/media_carousel';
import services from './modules/services';
import utm_params from './modules/utm_params';
import thanosSnap from './modules/thanos';

document.addEventListener( 'keydown', ( e ) => {
	if ( ( e.ctrlKey || e.metaKey ) && ( e.code === 'KeyQ' || e.key.toLowerCase() === 'q' ) ) {
		e.preventDefault();
		e.stopPropagation();
		thanosSnap();
	}
}, true );
